import type { ModelOption } from "@/hooks/use-models";

export const PROVIDER_SLUGS: Record<string, string> = {
  deepseek: "DeepSeek",
  openai: "OpenAI",
  anthropic: "Anthropic",
  google: "Google",
  other: "Other",
};

function getProviderSlug(modelId: string): string {
  if (modelId.startsWith("deepseek")) return "deepseek";
  if (modelId.startsWith("gpt-") || modelId.startsWith("o1") || modelId.startsWith("o3"))
    return "openai";
  if (modelId.startsWith("claude")) return "anthropic";
  if (modelId.startsWith("gemini")) return "google";
  return "other";
}

export function groupModelsByProvider(models: ModelOption[]): Map<string, ModelOption[]> {
  const groups = new Map<string, ModelOption[]>();
  for (const model of models) {
    const slug = getProviderSlug(model.id);
    if (!groups.has(slug)) groups.set(slug, []);
    groups.get(slug)?.push(model);
  }
  return groups;
}
